import { Dropdown, Menu } from 'antd';
import { formatMer } from 'components/pages/Mer/utils/utils';
import { Goal } from 'lib/data/models/Goals';
import { formatCurrency } from 'lib/utils/currency';
import { orZero } from 'lib/utils/NumUtils';
import React, { useState } from 'react';
import { getGoal, renderLoader } from 'utils/adaya/AdayaUtils';
import { daysInThisMonth, now } from 'utils/DateUtils.js';
import CurrencyInput from '../../../../shared/app/CurrencyInput';
import MerGraphWrapper from "../../../Mer/components/MerGraphWrapper";
import './style.scss';

const options = [
    'Revenue / Adspend',
    'MER / ROAS',
];

const EditGoals = (props) => {
    let { mobile, processedData, auth, processedROASData } = props;

    if (!processedData || !processedROASData) {
        return renderLoader();
    }

    const user = auth?.user;
    const account = user?.activeAccount;
    const accountAge = props.auth.getAccountAge();

    const revenueGoal = getGoal(account, Goal.Revenue);
    const merGoal = getGoal(account, Goal.Mer);
    const roasGoal = getGoal(account, Goal.Roas);
    const aovGoal = getGoal(account, Goal.Aov);
    const cppGoal = getGoal(account, Goal.Cpp);
    const adspendGoal = getGoal(account, Goal.Adspend);
    //const ordersGoal = getGoal(account, Goal.Orders);

    const [editRevenueGoal, setEditRevenueGoal] = useState(revenueGoal);
    const [editMerGoal, setEditMerGoal] = useState(merGoal);
    const [editRoasGoal, setEditRoasGoal] = useState(roasGoal);
    const [editAovGoal, setEditAovGoal] = useState(aovGoal);

    const totalAdspendValue = orZero((revenueGoal) / (merGoal));

    const _daysInThisMonth = daysInThisMonth();

    const {
        revenueData,
        adspendData,
        merData,
        orders,
        revenue,
        adspend,
        mer,
        aov,
        daysData
    } = processedData;

    const {
        roas,
        roasData,
    } = processedROASData;

    const [selectOption, setSelectOption] = useState(options[0]);

    let datasets = [];

    if (selectOption === 'Revenue / Adspend') {
        datasets = [];
        datasets.push({
            borderColor: "#66FFCC",
            borderWidth: 3,
            fill: true,
            label: "Revenue",
            pointRadius: 0,
            yAxisID: "y1",
            data: [...(revenueData || [])].reverse(),
        });

        datasets.push({
            borderColor: "#F33FFF",
            borderWidth: 3,
            fill: true,
            label: "Adspend",
            pointRadius: 0,
            yAxisID: "y2",
            data: [...(adspendData || [])].reverse()
        });
    } else {
        datasets = [];

        datasets.push({
            borderColor: "#66FFCC",
            borderWidth: 3,
            fill: true,
            label: "MER",
            pointRadius: 0,
            yAxisID: "y2",
            data: [...(merData || [])].reverse(),
        });

        datasets.push({
            borderColor: "#F33FFF",
            borderWidth: 3,
            fill: true,
            label: "ROAS",
            pointRadius: 0,
            yAxisID: "y1",
            data: [...(roasData || [])].reverse(),
        });
    }

    const formattedGraphData = {
        datasets,
        labels: [...(daysData || [])].reverse(),
    }

    const graphDropDown = (
        <Menu onClick={({ key }) => setSelectOption(key)}>
            {options.map(key => (
                <Menu.Item key={key}>
                    {key}
                </Menu.Item>
            ))}
        </Menu>
    )

    return (
        <div className="goals-edit-main">

            <div className="goals-edit page-layout top-section">

                {accountAge >= 3 &&
                    <div className="close" onClick={props.onClose}>
                        <img src="/static/images/x-circle.png" />
                    </div>
                }

                <div className="goal-inputs goal-inputs-8 section-col">
                    <div className="goals-card">
                        <div className="cells">
                            <h2>Target Store Revenue for {now().format('MMMM')}</h2>

                            <div className="cell revenue main-goal full num-with-label large no-line with-button bg-gray">
                                <div className="inner">
                                    <div className="input font-large">
                                        <CurrencyInput name="revenue" canEdit
                                            placeholder="Monthly Revenue Goal"
                                            value={editRevenueGoal}
                                            onChange={(v) => setEditRevenueGoal(v ? parseInt(v) : 0)}
                                            onSave={(v) => props.setRevenueGoal(v ? parseInt(v) : 0)}
                                            buttonProps={{ filled: false, round: true, color: 'green' }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="white-bg cells">
                            <div className="cell mer num-with-label with-button">
                                <div className="inner">
                                    <div className="label">Target MER</div>
                                    <div className="input">
                                        <CurrencyInput name="mer"
                                            placeholder="MER Goal"
                                            value={editMerGoal}
                                            onChange={(v) => setEditMerGoal(v || 0)}
                                            onSave={(v) => {
                                                let val = parseFloat(v || 0);
                                                setEditMerGoal(val);
                                                props.setMerGoal(val);
                                            }}
                                            canEdit
                                            buttonProps={{ round: true, color: 'green', textColor: '' }}
                                            prefix={false}
                                            precision="1"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="cell aov num-with-label">
                                <div className="inner">
                                    <div className="label">Target AD ROAS</div>
                                    <div className="input">
                                        <CurrencyInput name="roas"
                                            placeholder="ROAS"
                                            value={editRoasGoal}
                                            onChange={(v) => setEditRoasGoal(v || 0)}
                                            onSave={(v) => {
                                                let val = parseFloat(v || 0);
                                                setEditRoasGoal(val);
                                                props.setRoasGoal(val);
                                            }}
                                            canEdit
                                            buttonProps={{ round: true, color: 'green', textColor: '' }}
                                            prefix={false}
                                            precision={1}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className={`cell roas num-with-label with-button ${mobile ? 'bg-gray' : ''}`}>
                                <div className="inner">
                                    <div className="label">Target Store AOV</div>
                                    <div className="input">
                                        <CurrencyInput name="aov"
                                            placeholder="AOV Goal"
                                            value={editAovGoal}
                                            onChange={(v) => setEditAovGoal(v || 0)}
                                            onSave={(v) => {
                                                let val = parseFloat(v || 0);
                                                setEditAovGoal(val);
                                                props.setAovGoal(val);
                                            }}
                                            canEdit
                                            buttonProps={{ round: true, color: 'green', textColor: '' }}
                                        />
                                    </div>
                                </div>
                            </div>

                            {mobile && (
                                <div className="cell roas num-with-label bg-gray">
                                    <div className="inner">
                                        <div className="label">Orders</div>
                                        <div className="input">
                                            <CurrencyInput name="Orders"
                                                placeholder="Orders"
                                                defaultValue={Math.round((revenueGoal) / (aovGoal))}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                        </div>

                        <div className={`${mobile ? 'white-bg' : 'bg-gray'} cells`}>
                            {!mobile && (
                                <div className="cell daily-adspend num-with-label">
                                    <div className="inner">
                                        <div className="label">Orders</div>
                                        <div className="input">
                                            <div className="value">
                                                {Math.round((revenueGoal) / (aovGoal))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            <div className="cell daily-adspend num-with-label">
                                <div className="inner">
                                    <div className="label">Adspend/Month</div>
                                    <div className="input">
                                        <div className="value">{formatCurrency(orZero(totalAdspendValue))}</div>
                                    </div>
                                </div>
                            </div>

                            <div className="cell roas num-with-label">
                                <div className="inner">
                                    <div className="label">Daily Adspend</div>
                                    <div className="input">
                                        <div className="value">{formatCurrency(orZero(totalAdspendValue / _daysInThisMonth))}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div className="goal-inputs goal-inputs-4 section-col">
                    <h2>Recent Metrics - Last 30 days</h2>
                    <p className={`${selectOption === 'Revenue / Adspend' ? 'color-green' : ''}`}>Revenue: <span>{formatCurrency(revenue)}</span></p>
                    <p className={`${selectOption !== 'Revenue / Adspend' ? 'color-green' : ''}`}>MER: <span>{(formatMer(mer))}</span></p>
                    <p className={`${selectOption !== 'Revenue / Adspend' ? 'color-purpul-light' : 'color-light'}`}>ROAS: <span>{formatMer(roas)}</span></p>
                    <p>AOV: <span>{formatCurrency(aov)}</span></p>
                    <p className="color-light">Orders: <span>{orders}</span></p>
                    <p className={`${selectOption === 'Revenue / Adspend' ? 'color-purpul-light' : ''}`}>Adspend: <span>{formatCurrency(adspend)}</span></p>
                    <p className="color-light">Daily Adspend: <span>{formatCurrency(orZero(adspend / _daysInThisMonth))}</span></p>
                </div>

            </div>

            <div className="goals-edit page-layout graph-main bottom-section">
                <div className="goal-inputs section-col" style={{ flex: '.3 0 100%' }}>
                    <Dropdown
                        trigger="click"
                        overlay={graphDropDown}
                        overlayClassName="mer-dropdown-items"
                    >
                        <div className="mer-selected-item">{selectOption}</div>
                    </Dropdown>

                    {formattedGraphData !== undefined && <MerGraphWrapper
                        formattedGraphData={formattedGraphData}
                        selectedMetric="breakdown"
                        dailyGoal={3}
                        predictionState={null}
                    />}
                </div>
            </div>

        </div>
    )
}

export default EditGoals